import React, {useState, useEffect} from 'react';
import {withRouter, useParams, Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {toast} from 'react-toastify';
import {formatErrors} from '../../constants';
import {restoreAction} from '../../actions/loginAction';
import {InputLogin} from "../../utils/input/InputLogin";

function Password(props) {
  const {code} = useParams();
  const {history, restore} = props;
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [confirm, setConfirm] = useState(false);
  const [sent, setSent] = useState(false);
  const [form, handleChange] = useState({
    password: '', password2: ''
  });

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange({...form, [name]: value});
    setErrors({...errors, [name]: value.trim() === ''});
  };

  useEffect(() => {
    if (!code) {
      history.push('/login');
    }
    restore({code}).then((data) => {
      if (data.can_change) {
        setSent(true);
      } else {
        history.push('/login');
      }
    }).catch(err => {
      history.push('/login');
    });
  }, [code, history, restore]);


  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return false;
    }
    let errs = {};
    if (form.password === '') {
      errs.password = true;
    }
    if (form.password2 === '') {
      errs.password2 = true;
    }

    if (form.password !== form.password2) {
      errs.password2 = true;
    }
    setErrors(errs);

    if (Object.keys(errs).length > 0) {
      return false;
    }
    setLoading(true);

    props.restore({password: form.password, code}).then(() => {
      setLoading(false);
      setConfirm(true);
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  return <div className="auth">
    <form noValidate className="auth__wrapper" onSubmit={handleSubmit}>
       <div className="auth__top">
         <div className="auth__icon" style={{backgroundImage: "url(/img/logo-outline.svg)"}}></div>
         {(!sent || !confirm) && <h3 className="auth__title">Новый пароль</h3>}
         {sent && confirm && <h3 className="auth__title">Пароль изменен.</h3>}
       </div>

       <div className="auth__inner">
         {sent && !confirm && <React.Fragment>
           <InputLogin type="password"
                       name="password"
                       placeholder="Введите новый пароль"
                       title="Введите новый пароль"
                       value={form.password}
                       error={errors.password || false}
                       onChange={handleChangeForm}/>

           <InputLogin type="password"
                       name="password2"
                       placeholder="Повторите новый пароль"
                       title="Повторите новый пароль"
                       value={form.password2}
                       error={errors.password2 || false}
                       onChange={handleChangeForm}/>
         </React.Fragment>}
       </div>
       <div className="auth__buttons">
         {sent && confirm && <Link to="/login" className="auth__btn auth__btn--centered auth__btn--canceling btn">Войти</Link>}
         {(!sent || !confirm) && <button type="submit" className="auth__btn auth__btn--centered btn" disabled={loading}>Сохранить</button>}
       </div>
    </form>
  </div>;
}

const mapDispatchToProps = (dispatch) => {
  return {
    restore(data) {
      return dispatch(restoreAction(data));
    }
  }
};

export default connect(null, mapDispatchToProps)(withRouter(Password))
